import React, { Component } from 'react';
import Slider from 'react-slick';
import ResidentsAnimations from './residents_animations';
import { translationListToKeyValues } from '~/utils/translations';
import I18n from '~/utils/translations';
import SliderArrow from '~/components/slider_arrow';
import { respond, TABLET, DESKTOP, onResize, removeResize } from '~/utils/breakpoints';

export default class ShowcaseSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slidesToShow: this.numberOfSlidesToShow,
    };
  }

  componentDidMount() {
    ResidentsAnimations.initShowcase();
    ResidentsAnimations.addTriggerAfterLoad(20, '.showcase-slider', ResidentsAnimations.animateShowcase);
    onResize(this.setNumberOfSlidesToShow);
  }

  componentWillUnmount() {
    removeResize(this.setNumberOfSlidesToShow);
  }

  render = () => {
    const settings = {
      className: 'showcase-slider',
      dots: !this.props.hideDots,
      infinite: false,
      speed: 500,
      slidesToScroll: this.props.hideExtraSlides ? 0 : 1,
      slidesToShow: this.state.slidesToShow,
      nextArrow: (
        <SliderArrow
          customClasses="showcase__custom-slick-arrow showcase__custom-slick-arrow--next"
          color={this.props.arrowColor}
        />
      ),
      prevArrow: (
        <SliderArrow
          customClasses="showcase__custom-slick-arrow showcase__custom-slick-arrow--prev"
          color={this.props.arrowColor}
        />
      ),
    };

    return (
      <Slider {...settings}>
        {this.showcaseItems.map((step) => {
          return (
            <div className={`showcase-step ${this.animationClass()}`} key={step.key}>
              <h2
                className={`showcase-step-title ${
                  !this.shouldShowDescription(step) ? 'showcase-step-title--no-description' : ''
                }`}
              >
                {step.value.title}
              </h2>
              {this.shouldShowDescription(step) && (
                <h3 className="showcase-step-description">{this.showDescription(step)}</h3>
              )}
              {this.showItem(step)}
            </div>
          );
        })}
      </Slider>
    );
  };

  showItem = (item) => {
    if (item.value.video) {
      // this is hardcoded at the moment, but could be extracted easily to allow videos in phone frames across multiple slides
      return (
        <div className="showcase-step-image">
          <OwnerAppDemonstration
            contentKey="pages.residents.home_showcase.easy_video"
            autoPlay={true}
            videoUrl={item.value.video}
            autoPlay={item.value.autoplay}
            poster={item.value.poster}
            loop={item.value.loop}
            videoFrame="https://s3.eu-west-2.amazonaws.com/resident.ly-production-static-assets/product_screens/iphone-frame.png"
          />
        </div>
      );
    }

    return (
      <div className="showcase-step-image">
        <img src={item.value.image} />
      </div>
    );
  };

  get numberOfSlidesToShow() {
    if (respond(DESKTOP)) return 3;
    if (respond(TABLET)) return 2;

    return 1;
  }

  setNumberOfSlidesToShow = () => {
    this.setState({ slidesToShow: this.numberOfSlidesToShow });
  };

  showDescription = (item) => {
    if (this.useOldInternetDescription(item)) {
      return item.value.description_old;
    }
    return item.value.description;
  };

  shouldShowDescription = (item) => {
    return !!item.value.description;
  };

  useOldInternetDescription = (item) => {
    return (
      this.props.ENABLE_TV_INTERNET_SERVICES &&
      this.props.ENABLE_TV_INTERNET_SERVICES != 'true' &&
      item.value.title == 'Live easily'
    );
  };

  animationClass = () => {
    return this.props.animate ? 'animated' : '';
  };

  get showcaseItems() {
    if (this.props.contentKey) {
      return translationListToKeyValues(I18n.t(`pages.${this.props.contentKey}.items`));
    }

    return translationListToKeyValues(I18n.t('pages.residents.showcase.items'));
  }
}
